export const serverUrl = "https://rdfflfi.ph/help-desk-api/api";
// export const serverUrl = "http://10.10.13.5:4040/api";
